module.exports = __webpack_public_path__ + "img/logo.88e77790.png";